<template>
  <div>
    <slot v-if="isActive && hasSlotOrContent">
      <div class="content">
        {{ contentText }}
      </div>
    </slot>
  </div>
</template>

<script>
import routerLinkProps from '@/components/common/mixins/routerLinkProps';
import validator from '@/components/common/input/mixins/validator';

export default {
  name: 'NorticTab',
  mixins: [routerLinkProps, validator],
  props: {
    title: {
      type: String,
      required: true,
    },
    subtitle: {
      type: String,
      default: null,
    },
    icon: {
      type: [String, Object],
      default: null,
    },
    badge: {
      type: [Object],
      default: null,
    },
    data: {
      type: Object,
      default: null,
    },
    contentText: {
      type: String,
      default: null,
    },
    isDisabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      index: null,
    };
  },
  computed: {
    isActive() {
      return this.index === this.$parent.selectedIndexInner;
    },
    tabAsObject() {
      return {
        title: this.title,
        subtitle: this.subtitle,
        icon: this.icon,
        badge: this.badge,
        data: this.data,
        index: this.index,
        isDisabled: this.isDisabled,
        isActive: this.isActive,
        to: this.to,
        replace: this.replace,
        append: this.append,
        exact: this.exact,
        validatorResult: this.normalizedValidatorResult,
      };
    },
    hasSlotOrContent() {
      return this.$slots.default || this.contentText;
    },
  },
  watch: {
    tabAsObject: {
      handler() {
        if (this.$parent.tabObjects[this.index]) {
          this.$set(this.$parent.tabObjects, this.index, this.tabAsObject);

          if (this.isActive) {
            this.$parent.selectedTabObject = this.tabAsObject;
          }
        }
      },
      deep: true,
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.index = this.$parent.tabObjects.push(this.tabAsObject) - 1;
    });
  },
};
</script>

<style lang="scss" scoped>
  .content {
    padding: 10px;
  }
</style>
